import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  Button,
  ButtonToolbar,
  Clearfix,
  Glyphicon,
} from 'react-bootstrap';

import { getApiServerUrl } from '../../configuration/selectors';
import linkWithCredentials from '../../../utils/linkWithCredentials';
import { downloadingFileAndUpdatingCredentials } from '../../../utils/downloadUpdatingCredentials';

const propTypes = exact({
  payPeriod: PropTypes.object.isRequired,
  apiServerUrl: PropTypes.string.isRequired,
  isPayPeriodClosed: PropTypes.bool.isRequired,
});

const ExportPayPeriod = (props) => {
  const {
    payPeriod,
    apiServerUrl,
    isPayPeriodClosed,
  } = props;
  const { sage_csv_path: sageCsvPath } = payPeriod;
  // Be nice to not have to construct this here

  const renderMessage = () => {
    return (
      <p className="pull-left">
        Step 1: Export data to CSV and import into SAGE:
      </p>
    );
  };


  const openUrl = () => {
    const csvUrl = linkWithCredentials(`${apiServerUrl}${sageCsvPath}`);
    downloadingFileAndUpdatingCredentials(csvUrl);
  };

  return (
    <Clearfix>
      {isPayPeriodClosed && renderMessage()}
      <ButtonToolbar className="pull-right">
        <Button onClick={openUrl}>
          <Glyphicon glyph="export" style={{ marginRight: '0.5em' }} />
          Export Data to CSV
        </Button>
      </ButtonToolbar>
    </Clearfix>
  );
};

ExportPayPeriod.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    apiServerUrl: getApiServerUrl(state),
  };
};

const withRedux = connect(mapStateToProps, {});
const enhance = compose(withRedux);
export default enhance(ExportPayPeriod);
